import Utils from '../../utils/Utils';
import Validator from '../../utils/Validator';
import ItmMgr from '../../gui/ItmMgr';
import PSA from '../../psa';

export default class GrcRlr {

	constructor(properties) {
		Utils.bindAll(this, [ "layout", "onReady", "onRender" ]);
		this.ready = false;
		this.ruler = null;
		this.nowBlk = null;
		this.nowOvl = null;
		this.hdrTxt = null;
		this.nowBgc = null;
		this.nowFgc = null;
		this.nowBrc = null;
		this.brdClr = null;
		this.lbdClr = null;
		this.stgClr = null;
		this.isQrt = false;
		this.parent = rap.getObject(properties.parent);
		this.container = document.createElement('div');
		this.container.className = 'gccontainer';
		this.ovlcont = document.createElement('div');
		this.ovlcont.className = 'gccontainer gcrovl';
		this.parent.append(this.container);
		this.parent.append(this.ovlcont);
		const cwd = this.parent.getData("pisasales.CSTPRP.CWD") || {};
		this._init(cwd);
		this.parent.addListener("Resize", this.layout);
		rap.on("render", this.onRender);
	}

	destroy() {
		this._cleanup();
		this.parent = null;
		this.ready = false;
	}

	onReady() {
		this.ready = true;
	}

	onRender() {
		if ( this.container && this.container.parentNode ) {
			rap.off("render", this.onRender);
			this.onReady();
			this.layout();
		}
	}

	layout() {
		this.onNfyRsz();
	}

	/**
	 * adds the (blank separated) CSS class(es) to an element
	 * @param {HTMLElement} elm the element
	 * @param {String} css the CSS class(es); ignored if empty
	 */
	_addCssCls(elm, css) {
		if ( Validator.isString(css) ) {
			const classes = css.split(/\s+/).filter( ( c ) => c.length > 0 );
			if ( classes.length > 0 ) {
				elm.classList.add( ...classes );
			}
		}
	}

	_creNavBtn(mgr, dsc, nfy, css) {
		const btn = document.createElement('div');
		btn.className = 'gcbutton gcnavbtn';
		this._addCssCls(btn, css);
		const txt = document.createElement('span');
		txt.className = 'gcbutton';
		// size and style (light) of the arrow are given by the icon descriptor
		const ico = mgr.creDscIco(dsc, null, false);
		txt.appendChild(ico);
		btn.appendChild(txt);
		const self = this;
		btn.addEventListener('mouseup', function(e) {
			self._onBtnClk(nfy);
		});
		return btn;
	}

	_init(args) {
		const mgr = ItmMgr.getInst();
		if ( args.brdclr ) {
			this.brdClr = mgr.getRgb(args.brdclr);
		}
		if ( args.lbdclr ) {
			this.lbdClr = mgr.getRgb(args.lbdclr);
		}
		if ( args.stgclr ) {
			this.stgClr = mgr.getRgb(args.stgclr);
		}
		if ( args.nowbgc ) {
			this.nowBgc = mgr.getRgb(args.nowbgc);
		} else {
			this.nowBgc = 'rgba(255, 122, 0, 0.25)';
		}
		if ( args.nowfgc ) {
			this.nowFgc = mgr.getRgb(args.nowfgc);
		} else {
			this.nowFgc = 'rgb(255, 122, 0)';
		}
		if ( args.nowbrc ) {
			this.nowBrc = mgr.getRgb(args.nowbrc);
		} else {
			this.nowBrc = 'rgb(255, 143, 41)';
		}

		const hl = document.createElement('div');
		hl.className = 'gcheadline';

		const ba = document.createElement('div');
		ba.className = 'gcbtnarea';

		const tdy = args.ttltdy || 'Today';

		// additional CSS class(es) for all buttons (given by the Java side, e.g. rounded corners)
		const btn_css = args.buttonCssClass;

		const btn_tdy = document.createElement('div');
		btn_tdy.className = 'gcbutton btntdy';
		this._addCssCls(btn_tdy, btn_css);
		const txt_tdy = document.createElement('span');
		txt_tdy.className = 'gcbutton';
		txt_tdy.innerText = tdy;
		btn_tdy.appendChild(txt_tdy);
		ba.appendChild(btn_tdy);

		const self = this;
		btn_tdy.addEventListener('mouseup', function(e) {
			self._onBtnClk('tdy');
		});

		if ( args.btnlft ) {
			const btn = this._creNavBtn(mgr, args.btnlft, 'lft', btn_css);
			ba.appendChild(btn);
		}
		if ( args.btnrgt ) {
			const btn = this._creNavBtn(mgr, args.btnrgt, 'rgt', btn_css);
			ba.appendChild(btn);
		}

		const ht = document.createElement('span');
		ht.className = 'gcheadline';
		hl.appendChild(ba);
		hl.appendChild(ht);

		this.hdrTxt = ht;
		this.container.appendChild(hl);

		const r = document.createElement('div');
		r.className = 'gcruler';
		this.ruler = r;
		this.container.appendChild(r);
	}

	_cleanup() {
		this._clrNowOvl();
		this.ready = false;
		this.container = null;
		this.ovlcont = null;
		this.ruler = null;
		this.hdrTxt = null;
	}

	_onBtnClk(btn) {
		this._nfySrv('btnclk', btn);
	}

	_nfySrv(code, par) {
		if ( this.ready ) {
			const param = {};
			param.cod = code;
			param.par = par;
			rap.getRemoteObject(this).notify("GRC_RLR_NFY", param);
		}
	}

	_clrNowOvl() {
		this.nowBlk = null;
		if ( this.nowOvl ) {
			const ovl = this.nowOvl;
			this.nowOvl = null;
			ovl.parentNode.removeChild(ovl);
		}
	}

	_addNowOvl(now) {
		this._clrNowOvl();
		this.nowBlk = now;
	}

	_creNowOvl() {
		if ( this.nowBlk && this.nowFgc && this.ovlcont ) {
			const brd = '1px solid ' + this.nowFgc;
			const ovl = document.createElement('div');
			ovl.className = 'gcrovl gcrnowovl';
			ovl.style.zIndex = 12345678;
			ovl.style.borderLeft = brd;
			ovl.style.borderTop = brd;
			ovl.style.borderRight = brd;
			this.ovlcont.appendChild(ovl);
			this.nowOvl = ovl;
		}
	}

	_plcNowOvl() {
		if ( this.nowBlk && this.ovlcont ) {
			const clr = this.ovlcont.getBoundingClientRect();
			if ( clr.width > 0 ) {
				if ( !this.nowOvl ) {
					this._creNowOvl();
				}
				if ( this.nowOvl ) {
					const rct = this.nowBlk.getBoundingClientRect();
					const ovl = this.nowOvl;
					const wdt = rct.width;
					const hgt = rct.height;
					const par = {};
					par.x = rct.left - clr.left - 1;
					par.w = wdt + 1;
					if ( par.x < 0 ) {
						par.w += par.x;
						par.x = 0;
					}
					const vof = this.isQrt ? 1 : 0;
					par.t = rct.top - clr.top - vof;
					par.h = hgt + vof;
					ovl.style.left = '' + par.x + 'px';
					ovl.style.width = '' + par.w + 'px';
					ovl.style.top = '' + par.t + 'px';
					ovl.style.height = '' + par.h + 'px';
					this._nfySrv('ovlRsz', par);
				}
			}
		}
	}

	_addBlockLsr(b, o) {
		const self = this;
		const tms = 'tms' + b.tms;
		o.style.cursor = 'pointer';
		o.addEventListener('mouseup', function(e) {
			self._onBtnClk(tms);
		});
	}

	_creBlocks(blocks, nam) {
		const mgr = ItmMgr.getInst();
		const r = this.ruler;
		const l = blocks.length;
		const is_day = ('DAY' === nam) || ('MONTH' === nam);
		const is_qrt = !is_day && ('QUARTER' === nam);
		r.innerHTML = '';
		this._clrNowOvl();
		this.isQrt = is_qrt;
		const base = 100.0 / l;
		for ( let i = 0; i < l; ++i ) {
			const b = blocks[i];
			const is_last = (i === (l - 1));
			const is_now = b.now && !is_qrt;
			const nxt_now = !is_now && !is_qrt && !is_last && blocks[i + 1].now;
			let brc_top = is_now ? null : this.brdClr;
			let brc_rgt = brc_top;
			const is_oop = !is_now && b.oop;
			if ( !is_now && !nxt_now && b.stg && !is_last && this.stgClr ) {
				brc_rgt = this.stgClr;
			}
			const o = document.createElement('div');
			o.className = 'gcrblock' + (is_now ? ' gcnow' : (is_oop ? ' gcoop' : ''));
			o.style.flexBasis = '' + base + '%';
			if ( brc_top ) {
				o.style.borderTop = '1px solid ' + brc_top;
			}
			if ( brc_rgt ) {
				o.style.borderRight = '1px solid ' + brc_rgt;
			}
			if ( is_now ) {
				o.style.backgroundColor = this.nowBgc;
				this._addNowOvl(o);
			}
			let has_htx = false;
			let has_mtx = false;
			const has_sub = b.sub && (b.sub.length > 0);
			if ( Validator.isString(b.htx) || Validator.isString(b.hx2) ) {
				has_htx = true;
				const htc = document.createElement('div');
				htc.className = 'gcbhtxcnt';
				if ( Validator.isString(b.htx) ) {
					const htx = document.createElement('div');
					htx.className = 'gcbhdrtxt gcbhtx' + nam.toLowerCase();
					htx.innerText = b.htx;
					if ( is_now ) {
						htx.style.color = this.nowFgc;
					}
					htc.appendChild(htx);
				}
				if ( Validator.isString(b.hx2) ) {
					const hx2 = document.createElement('div');
					hx2.className = 'gcbhdrtx2 gcbhtx' + nam.toLowerCase();
					hx2.innerText = b.hx2;
					htc.appendChild(hx2);
				}
				o.appendChild(htc);
			}
			if ( Validator.isString(b.txt) ) {
				const mt = document.createElement('div');
				mt.className = 'gcbmaintxt gcbmtx' + nam.toLowerCase();
				mt.innerText = b.txt;
				if ( is_now ) {
					mt.style.color = this.nowFgc;
				}
				o.appendChild(mt);
				has_mtx = true;
				if ( !has_sub ) {
					if ( !has_htx ) {
						mt.style.paddingLeft = '0px';
					}
					if ( Validator.isString(b.shx) ) {
						const shx = document.createElement('div');
						shx.className = 'gcbsubhtx';
						shx.innerText = b.shx;
						if ( is_now ) {
							shx.style.color = this.nowFgc;
						}
						o.appendChild(shx);
					}
				}
			}
			if ( has_sub ) {
				const il = document.createElement('div');
				il.className = 'gcbitemline';
				const sub_brc = this.lbdClr;
				const sub_typ = 'solid';
				if ( sub_brc ) {
					il.style.borderTop = '1px ' + sub_typ + ' ' + sub_brc;
				}
				const sl = b.sub.length;
				const sb = 100.0 / sl;
				for ( let k = 0; k < sl; ++k ) {
					const sub = b.sub[k];
					const sd = document.createElement('div');
					sd.className = 'gcbsubitem';
					if ( !is_qrt ) {
						sd.className += ' gcb' + sub.srn;
						if ( (k % 2) !== 0 ) {
							sd.className += '1';
						} else {
							if ( (k % 4) !== 0 ) {
								sd.className += '2';
							} else {
								sd.className += '4';
							}
						}
					}
					sd.style.flexBasis = '' + sb + '%';
					let eff_brc = sub_brc;
					let eff_brr = null;
					if ( sub_brc && (k < (sl - 1)) ) {
						eff_brr = '1px ' + sub_typ + ' ' + eff_brc;
					}
					let st = null;
					if ( Validator.isString(sub.txt) ) {
						st = document.createElement('span');
						st.className = 'gcbsubitem';
						if ( is_qrt ) {
							st.className += ' gcbsubday';
						}
						st.innerText = sub.txt;
						sd.appendChild(st);
					}
					if ( is_qrt ) {
						const sub_now = !!sub.now;
						const sub_oop = !!sub.oop;
						const sub_hlt = !!sub.hlt;
						if ( sub_oop || sub_hlt ) {
							sd.className += ' ' + (sub_hlt ? 'gchlt' : 'gcoop');
						} else if ( sub_now ) {
							sd.className += ' gcnow';
							sd.style.backgroundColor = this.nowBgc;
							eff_brr = null;
							this._addNowOvl(sd);
							if ( st ) {
								st.style.color = this.nowFgc;
							}
						}
					}
					if ( Validator.isString(eff_brr) ) {
						sd.style.borderRight = eff_brr;
					}
					il.appendChild(sd);
				}
				o.appendChild(il);
			} else if ( !has_htx && has_mtx ) {
				o.style.justifyContent = 'center';
				o.style.alignItems = 'center';
			}
			if ( b.tms ) {
				this._addBlockLsr(b, o);
			}
			r.appendChild(o);
		}
		this._plcNowOvl();
	}

	setRlrData(args) {
		if ( this.hdrTxt && Validator.isString(args.hdrtxt) ) {
			this.hdrTxt.innerText = args.hdrtxt;
		}
		if ( this.ruler && args.blocks && args.blocks.length ) {
			this._creBlocks(args.blocks, args.prdnam);
		}
	}

	setGrcCmp(args) {
		const idc = args || '';
		if ( Validator.isString(idc) ) {
			const cmp = PSA.getInst().glbWdgReg.getObj(idc);
			if ( cmp ) {
				cmp.setRuler(this);
			}
		}
	}

	onNfyRsz() {
		this._plcNowOvl();
	}

	static register() {
		rap.registerTypeHandler("pisasales.GrcRlr", {
			factory: function(properties) {
				return new GrcRlr(properties);
			},
			destructor: "destroy",
			properties: [ "rlrData", "grcCmp" ],
			methods: [ "onNfyRsz" ],
			events: [ "GRC_RLR_NFY" ]
		});
	}
}
